// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-content p ol li{

    margin:15px 100px;
    color: #555;
    font-size: 16px;
}

.terms-content h2 {

    margin:15px 100px;
    color: #555;

}

.terms-content {
    line-height: 1.6;
    color: #333;
    padding:30px 300px;
    margin: auto;
    text-align: start;
}`, "",{"version":3,"sources":["webpack://./src/pages/Policy/styles.css"],"names":[],"mappings":"AAAA;;IAEI,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;IACjB,WAAW;;AAEf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB","sourcesContent":[".terms-content p ol li{\n\n    margin:15px 100px;\n    color: #555;\n    font-size: 16px;\n}\n\n.terms-content h2 {\n\n    margin:15px 100px;\n    color: #555;\n\n}\n\n.terms-content {\n    line-height: 1.6;\n    color: #333;\n    padding:30px 300px;\n    margin: auto;\n    text-align: start;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
